import { render } from "./AlternatePageButton.vue?vue&type=template&id=55ffad4e&scoped=true"
import script from "./AlternatePageButton.vue?vue&type=script&lang=js"
export * from "./AlternatePageButton.vue?vue&type=script&lang=js"

import "./AlternatePageButton.vue?vue&type=style&index=0&id=55ffad4e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ffad4e"]])

export default __exports__